import { resolveHref } from 'next/dist/client/resolve-href'
import Router from 'next/router'
import { ENABLE_BROWSER_ACCESS } from './env'
import { graphql } from './gql'
import { getCurrentClient } from './urql'

let ready: Function = () => {}
export const flutterReady = new Promise((resolve) => void (ready = resolve))

// lazy contruct promise to load app version
let appVersionPromise: Promise<AppInfo | null> | null = null
export function loadAppVersion(): Promise<AppInfo | null> {
  if (appVersionPromise) return appVersionPromise
  appVersionPromise = flutterReady.then(() =>
    window.flutter_inappwebview.callHandler('getAppInfo')
  )
  return appVersionPromise
}

if (typeof window !== 'undefined') {
  window.addEventListener('flutterInAppWebViewPlatformReady', () => ready())

  window.sendFCMToken = async function (token) {
    const client = getCurrentClient()

    const result = await client
      .mutation(FCMTokenCreateMutation, {
        input: { token },
      })
      .toPromise()

    // handle error?
    if (result.data?.fcmTokenCreate?.errors?.length) {
      console.error(result)
      return false
    }

    return true
  }

  window.sendFCMData = async function (data) {
    // TODO: after binary is update, we will add process
    const dataObj: {
      'notification.title': string
      'notification.body': string
      'notification.sendTime': string
      event_type: string
      user_id: string
      player_id: string
      expl_player_report_id: string
      sent_time: string
      message_category: string
    } = JSON.parse(data)

    // Due to bug in native app, initial fcm will alway be sent to frontend on
    // page load, so we must check if we have handled the message or not before continue
    const messageKey = `${dataObj['notification.title']}/${dataObj.sent_time}`
    const localStorageKey = 'handled_nottifications'
    let handledNotifications = []
    try {
      const value = window.localStorage.getItem(localStorageKey)
      if (value) {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) handledNotifications = parsed
      }
    } catch (e) {}

    // skip if we already handled it
    if (handledNotifications.indexOf(messageKey) >= 0) return true

    // mark current message key as handled
    handledNotifications.push(messageKey)
    // only remember last 5 message id
    if (handledNotifications.length >= 5) {
      handledNotifications = handledNotifications.slice(
        handledNotifications.length - 5
      )
    }
    window.localStorage.setItem(
      localStorageKey,
      JSON.stringify(handledNotifications)
    )

    if (dataObj.player_id) {
      const query: Record<string, string> = { playerId: dataObj.player_id }
      if (dataObj.message_category) {
        query.category = dataObj.message_category
      }
      const [, resolvedHref] = resolveHref(
        Router,
        {
          pathname: '/app/players/[playerId]',
          query,
        },
        true
      )
      if (resolvedHref) {
        window.location.href = resolvedHref
      }
    }
    return true
  }

  // on normal browser, flutterInAppWebViewPlatformReady won't be fired
  // we should mock flutter_inappwebview for normal browser access
  if (ENABLE_BROWSER_ACCESS && !window.flutter_inappwebview) {
    let auth: { username: string; password: string } | null = null
    window.flutter_inappwebview = {
      async callHandler(handler, args?: any) {
        switch (handler) {
          case 'getAppInfo':
            return {
              app_name: 'LOGIQ LABO® 学習者アプリ',
              app_version: '0.0.0',
              platform: 'iOS',
            } as any
          case 'uLogin':
            auth = args
            return
          case 'getUserInfo':
            return auth as any
          case 'openURL':
            const url = args.url
            window.open(url, '_blank')
            return
        }
      },
    }
    ready()
  }
}

export const FCMTokenCreateMutation = graphql(`
  mutation FCMTokenCreateMutation($input: FcmTokenCreateInput!) {
    fcmTokenCreate(input: $input) {
      errors {
        ... on BaseError {
          __typename
          field
          message
        }
      }
    }
  }
`)

export async function hasNativeShare(): Promise<boolean> {
  await flutterReady
  const allHooks =
    (await window.flutter_inappwebview.callHandler('getAllHooks')) || []
  return allHooks.includes('nativeShare')
}

export async function nativeShare(
  title?: string,
  text?: string,
  files?: string[]
): Promise<void> {
  await flutterReady
  return window.flutter_inappwebview.callHandler('nativeShare', {
    title,
    text,
    files,
  })
}
